import React from "react";
import { ButtonVariant } from "../../shared/utils/enums";
import { IButton } from "../../interfaces/IButton";

const Button: React.FC<IButton> = ({
  variant = ButtonVariant.PRIMARY,
  children,
  onClick,
  style,
  disabled,
  className,
  ...rest
}) => {
  const baseClasses =
    "rounded-md font-semibold focus:outline-none transition-transform duration-150 ease-in-out active:[transform:scale(0.98)] inline-flex items-center justify-center";

  const variantClasses = {
    [ButtonVariant.PRIMARY]:
      "bg-primary hover:bg-primary/90 text-white px-4 py-2 text-sm dark:bg-primary-700 dark:hover:bg-primary-800 dark:text-white",
    [ButtonVariant.SECONDARY]:
      "bg-gray-200/40 dark:bg-gray-800 text-gray-900 dark:text-white hover:bg-gray-200/70 dark:hover:bg-gray-700 px-3.5 py-2.5 text-sm",
    [ButtonVariant.CLEAR]:
      "bg-transparent hover:bg-gray-200 dark:hover:bg-gray-700/20 text-primary text-sm",
    [ButtonVariant.DANGER]:
      "bg-transparent hover:bg-gray-100 dark:hover:bg-red-700/20 text-red-600 text-sm",
    [ButtonVariant.DELETE]:
      "bg-red-600 hover:bg-red-700 text-white min-w-[120px] text-sm dark:bg-red-700 dark:hover:bg-red-800 dark:text-white",
  };

  const disabledClasses = disabled ? "opacity-50 cursor-not-allowed" : "";

  const classes = [
    baseClasses,
    variantClasses[variant],
    disabledClasses,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      onClick={onClick}
      style={style}
      disabled={disabled}
      className={classes}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
